import * as Types from "../actionTypes/reportTypes";

const initialState = {
  sData: [],
  loading: false,
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_REPORT_LIST:
      return { ...state, sData: action.payload };
    case Types.GET_REPORT_LIST_LOADING:
      return { ...state, loading: action.payload };
    case Types.GET_REPORT_LIST:
      return action.payload;
    case Types.SUBMIT_REPORT:
      const tmpState = { ...state };
      tmpState.sData = state.sData.map((data) =>
        data.Seq === action.payload ? { ...data, Send_YN: "Y" } : data,
      );
      return tmpState;
    default:
      return state;
  }
};

export default reportReducer;
